import { ArrowForwardIcon, CheckIcon } from "@chakra-ui/icons";
import { Box, Button, Container, Flex, Text } from "@chakra-ui/react";
import usePracticeUtil from "./usePracticeUtil";
import { useSelector } from "react-redux";

function EndOfLesson() {
    const { lessonExercises } = useSelector(
        store => store.mainReducer
    )
    const { moveToNextLesson } = usePracticeUtil()
    const hasLessons = () => !!lessonExercises?.length

    return (
        <Container className="lesson-completed-container" centerContent minH="100vh" display="flex" alignItems="center" w='100%'>
            <Flex direction="column" align="center" textAlign="center" spacing={4}>
                <Box
                    p={4}
                    mb={4}
                    borderRadius="full"
                    bg="green.500"
                    color="white"
                    boxSize="60px"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                >
                    <CheckIcon w={8} h={8} />
                </Box>

                <Text fontSize="2xl" fontWeight="bold" mb={2}>
                    {hasLessons() ? ' End of Lesson!' : 'No Exercises here'}
                </Text>
                <Text fontSize="lg" color="gray.600" mb={8}>
                    Ready for the next lesson?
                </Text>

                <Button
                    variant="primary"
                    width="100%"
                    style={{
                        height: '48px',
                    }}
                    rightIcon={<ArrowForwardIcon />}
                    px={8}
                    onClick={moveToNextLesson}
                >
                    Continue Learning
                </Button>
            </Flex>
        </Container>
    );


}

export default EndOfLesson